import axios from "axios";
import { TOKEN_IGNORE_APIS } from "constant";
import Enum from "enum/Enum";
import * as uuid from "uuid";

// const channelId = uuid.v4();
window.channelId = uuid.v4();
const channelId = window.channelId;
// sessionStorage.setItem("channelId", channelId);

const tokenChannel = new BroadcastChannel("tokenChannel");
const channel = new BroadcastChannel("requestErrorChannel");

const serviceRequest = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL || "/data-service-portal",
	timeout: 30000,
});

serviceRequest.interceptors.request.use((config) => {
	const { url } = config;
	const accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.Authorization = `Bearer ${accessToken}`;
	}
	if (TOKEN_IGNORE_APIS.includes(url)) {
		config.headers.Authorization = null;
	}

	return config;
});

serviceRequest.interceptors.response.use(
	(response) => {
		sessionStorage.removeItem("isMaintenance");
		if (response.status === 200) {
			if (response.data.code === 200) {
				return response.data;
			}
		} else {
			const message = response.data?.detail ?? response.data?.message ?? "Server Internal Error";
			throw new HttpError(message, response);
		}
		return response;
	},
	async (error) => {
		const originalRequest = error.config;
		if (error.response) {
			const { status, statusText, data } = error.response;

			// For blob responses, the error body may be a Blob containing JSON — parse it first
			let parsedData = data;
			if (originalRequest.responseType === "blob" && data instanceof Blob) {
				try {
					const text = await data.text();
					parsedData = JSON.parse(text);
				} catch (e) {
					parsedData = data;
				}
			}

			const { code, message } = parsedData;
			console.log("response   error", status, originalRequest);
			// if status code === 401, try to refresh token,  skip code validation when responseType is "blob"
			if (status === 401 && (code == Enum.ERROR_CODE.TOKEN_INVALID || originalRequest.responseType === "blob")) {
				return await handleRefreshToken(originalRequest);
			}

			if (status === 501) {
				console.error("response error: Server Internal Error", data);
				return Promise.response({
					code: 501,
					message: data,
				});
			}

			// for first time login, need to change password
			// code = 510 scanner code error
			if (status === 500 && code === Enum.ERROR_CODE.NEED_TO_CHANGE_PASSWORD) {
				return Promise.reject({
					code,
					message,
				});
			}

			if (status === 500 || (status === 401 && code == Enum.ERROR_CODE.NO_AUTHORITY)) {
				// if code === 510 show detail error message
				const { noErrorMessage = false } = originalRequest;
				if (!noErrorMessage) {
					if ([Enum.ERROR_CODE.NO_AUTHORITY, Enum.ERROR_CODE.SHOW_DETAIL_ERROR].includes(code)) {
						channel.postMessage({
							msg: message || "Server Internal Error",
							channelId,
						});
						return Promise.reject({
							code,
							message,
						});
					} else {
						channel.postMessage({
							msg: "Server Internal Error",
							channelId,
						});
					}
				}

				return Promise.reject({
					code,
					message: message || "Server Internal Error",
				});
			}

			if ([502, 504].includes(status) && ["/login", "/Login"].includes(window.location.pathname)) {
				sessionStorage.setItem("isMaintenance", true);
				window.location.href = "/maintenance";
			}

			if (status === 413 && statusText === "Request Entity Too Large") {
				channel.postMessage({
					msg: "The file size exceeds the limit",
					channelId,
				});
			}

			console.error(`response Status:${status}, ${data}`);
		}
		console.log("response error", error);
		return Promise.reject(error);
	}
);

// pages don't need to refresh token, exclude some page can view without token

const excludeRefreshTokenPage = ["/login", "/Login", "/signup", "/forgotPswSendEmail", "/resetPwdNew"];

let isRefreshing = false; // isRefreshing
let refreshSubscribers = []; // store waiting requests

const handleRefreshToken = async (originalRequest) => {
	if (!originalRequest._retry && !excludeRefreshTokenPage.includes(window.location.pathname)) {
		if (isRefreshing) {
			return new Promise((resolve) => {
				// push waiting requests into a queue
				refreshSubscribers.push((token) => {
					originalRequest.headers.Authorization = `Bearer ${token}`;
					resolve(serviceRequest(originalRequest));
				});
			});
		}
		originalRequest._retry = true;
		isRefreshing = true;

		try {
			const refreshToken = sessionStorage.getItem("refreshToken");
			const response = await axios.post(
				"/data-service-portal/api/api/refreshToken",
				{
					refresh_token: refreshToken,
				},
				{
					headers: {
						refresh_token: refreshToken,
					},
				}
			);

			const newToken = response.data.data.accessToken;
			sessionStorage.setItem("accessToken", response.data.data.accessToken);
			sessionStorage.setItem("refreshToken", response.data.data.refreshToken);
			refreshSubscribers.forEach((cb) => cb(newToken));
			refreshSubscribers = [];

			originalRequest.headers.Authorization = `Bearer ${newToken}`;
			return await serviceRequest(originalRequest);
		} catch (refreshError) {
			if (refreshError?.response?.status === 401) {
				// if refresh fail, go login page
				const userInfo = JSON.parse(sessionStorage.getItem("DATA_SERVICES_USER") ?? "{}");
				// sessionStorage.clear();
				tokenChannel.postMessage({
					logout: true,
					userId: userInfo?.user?.id,
				});
			}
			return Promise.reject(refreshError);
		} finally {
			isRefreshing = false;
		}
	}
};

export default serviceRequest;
